import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
  users: [],
  loading: false,
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    userRequest(state) {
      state.loading = true;
      state.error = null;
    },
    userSuccess(state, action) {
      state.loading = false;
      state.users = action.payload;
    },
    userAddSuccess(state, action) {
      state.loading = false;
      state.users.push(action.payload);
    },
    userEditSuccess(state, action) {
      state.loading = false;
      state.users = state.users.map((user: { id: any; }) =>
        user.id === action.payload.id ? action.payload : user
      );
    },
    userDeleteSuccess(state, action) {
      state.loading = false;
      state.users = state.users.filter((user: { id: any; }) => user.id !== action.payload);
    },
    userError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  // New reducer for fetching user by ID
  getUserByIdRequest(state) {
    state.loading = true;
    state.error = null;
  },
  getUserByIdSuccess(state, action) {
    state.loading = false;
    state.user = action.payload;  // Store the user fetched by ID in `user`
  },
  getUserByIdError(state, action) {
    state.loading = false;
    state.error = action.payload;
  },

  },
});

export const {
  userRequest,
  userSuccess,
  userAddSuccess,
  userEditSuccess,
  userDeleteSuccess,
  userError,
  getUserByIdSuccess,
  getUserByIdError,
  getUserByIdRequest
} = userSlice.actions;

export default userSlice.reducer;
